<article class="survey-kpi-card">
  @if (icon()) {
    <mat-icon class="survey-kpi-card__icon" aria-hidden="true">{{ icon() }}</mat-icon>
  }

  <p class="survey-kpi-card__label">{{ label() }}</p>
  <p class="survey-kpi-card__value">{{ display_value() }}</p>

  @if (hint()) {
    <p class="survey-kpi-card__hint">{{ hint() }}</p>
  }

  @if (progress()) {
    <div class="survey-kpi-card__progress">
      <div class="survey-kpi-card__progress-meta">
        <span>Respuestas</span>
        <span>{{ progress_label() }}</span>
      </div>
      <mat-progress-bar mode="determinate" [value]="progress_percent()"></mat-progress-bar>
    </div>
  }
</article>
